// Delt SMS/RCS-logik (GatewayAPI). Ingen afhængigheder, så den kan testes og bruges i edge-funktionen send-besked.
import { erStaging, stagingIkkeSendt } from './staging.ts';

/** Telefonnummer → MSISDN uden plus (dansk nummer får 45 foran). null = ugyldigt. */
export function msisdn(tlf: string): string | null {
  let d = tlf.replace(/[\s\-().]/g, '');
  if (d.startsWith('+')) d = d.slice(1); else if (d.startsWith('00')) d = d.slice(2); else if (/^\d{8}$/.test(d)) d = '45' + d;
  return /^\d{10,15}$/.test(d) ? d : null;
}

const GSM = '@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ !"#¤%&\'()*+,-./0123456789:;<=>?¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà';
const GSM_EKSTRA = '^{}\\[~]|€';
/** Antal SMS'er, en tekst fylder (prisen ganges med dette). GSM: 160/153 tegn, ellers (fx emoji) UCS-2: 70/67. */
export function smsDele(tekst: string): number {
  let gsm = true, laengde = 0;
  for (const c of tekst) { if (GSM.includes(c)) laengde += 1; else if (GSM_EKSTRA.includes(c)) laengde += 2; else { gsm = false; break; } }
  if (!gsm) { const n = [...tekst].length; return n <= 70 ? 1 : Math.ceil(n / 67); }
  return laengde <= 160 ? 1 : Math.ceil(laengde / 153);
}

/** Afsendernavn: højst 11 tegn, bogstaver/tal (GatewayAPI/operatørernes krav). */
export function afsender(navn: string): string {
  const a = navn.normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/æ/gi, 'ae').replace(/ø/gi, 'oe').replace(/å/gi, 'aa').replace(/[^A-Za-z0-9]/g, '').slice(0, 11);
  return a || 'Freemi';
}

export type Resultat = { kanal: 'rcs' | 'sms'; id: string | null; dele: number };
/** Send: RCS først (hvis klienten har en godkendt RCS-agent og RCS er slået til), ellers – eller hvis RCS fejler – SMS. */
export async function sendBesked(o: { til: string; tekst: string; afsender: string; token: string; rcsUrl?: string | null; rcsAgent?: string | null; f?: typeof fetch }): Promise<Resultat> {
  const f = o.f ?? fetch;
  const nr = msisdn(o.til); if (!nr) throw new Error('Ugyldigt telefonnummer');
  if (erStaging()) { stagingIkkeSendt('sms', nr); return { kanal: 'sms', id: 'staging-ikke-sendt', dele: smsDele(o.tekst) }; }
  const hdr = { authorization: `Token ${o.token}`, 'content-type': 'application/json' };
  if (o.rcsUrl && o.rcsAgent) {
    try {
      const r = await f(o.rcsUrl, { method: 'POST', headers: hdr, body: JSON.stringify({ agent: o.rcsAgent, recipient: nr, text: o.tekst }), signal: AbortSignal.timeout(8000) });
      if (r.ok) { const j = await r.json().catch(() => ({})); return { kanal: 'rcs', id: String(j.id ?? j.ids?.[0] ?? '') || null, dele: 1 }; }
    } catch { /* telefonen kan ikke RCS, eller RCS svarer ikke: send SMS */ }
  }
  const r = await f('https://gatewayapi.eu/rest/mtsms', { method: 'POST', headers: hdr, body: JSON.stringify({ sender: afsender(o.afsender), message: o.tekst, recipients: [{ msisdn: Number(nr) }] }), signal: AbortSignal.timeout(10000) });
  const j = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(j?.message ?? `GatewayAPI svarede ${r.status}`);
  return { kanal: 'sms', id: String(j.ids?.[0] ?? '') || null, dele: smsDele(o.tekst) };
}
